// v2/utils/mapDashboard.js — /api/v2/dashboard/ cevabini guvenli sekle getirir
const dizi = (v) => (Array.isArray(v) ? v : []);

const sayi = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const sayiVeyaNull = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

// Bitis tarihi bu kadar yil ilerideyse "Suresiz" gosterilir (orn. 2050)
const SURESIZ_YIL = 10;

/** Ilk dolu elemana kadar olan bos (0) kayitlari atar */
export function bastakiBoslariAt(liste, alan = 'v') {
  const i = liste.findIndex((x) => sayi(x[alan]) !== 0);
  return i < 0 ? [] : liste.slice(i);
}

function mapIndirim(x, buYil) {
  const bitisYil = x.endsAt ? Number(String(x.endsAt).slice(0, 4)) : NaN;
  return {
    id: x.id,
    name: x.name || '',
    kind: x.kind === 'customer' ? 'customer' : 'general',
    scope: x.scope === 'product' ? 'product' : 'group',
    target: x.target || '',
    targetName: x.targetName || '',
    rates: dizi(x.rates).map(sayi).filter((r) => r > 0),
    effective: sayi(x.effective),
    endsAt: x.endsAt || null,
    daysLeft: sayiVeyaNull(x.daysLeft),
    endingSoon: Boolean(x.endingSoon),
    openEnded: Number.isFinite(bitisYil) && bitisYil - buYil >= SURESIZ_YIL,
  };
}

export function mapDashboard(v) {
  const d = v || {};
  const buYil = d.asOf ? Number(String(d.asOf).slice(0, 4)) : new Date().getFullYear();
  const kat = d.categories || null;
  const sv = d.savings || null;
  const ad = d.activeDiscounts || null;
  const gp = (ad && ad.generalProducts) || {};

  return {
    asOf: d.asOf || null,
    partial: Boolean(d.partial),

    year: d.year
      ? {
          year: sayi(d.year.year),
          sales: sayi(d.year.sales),
          returns: sayi(d.year.returns),
          net: sayi(d.year.net),
          invoices: sayi(d.year.invoices),
        }
      : null,

    purchaseMonths: dizi(d.purchaseMonths).map((m) => ({
      id: m.id,
      label: m.label,
      total: sayi(m.total),
      changePct: sayiVeyaNull(m.changePct),
      compareToDay: sayi(m.compareToDay),
      partial: Boolean(m.partial),
      series: dizi(m.series).map((p) => ({ day: p.day, value: sayi(p.value) })),
    })),

    recentInvoices: dizi(d.recentInvoices),

    categories: kat
      ? {
          year: sayi(kat.year),
          totalAmount: sayi(kat.totalAmount),
          totalQty: sayi(kat.totalQty),
          items: dizi(kat.items).map((it) => ({
            name: it.name || '',
            amount: sayi(it.amount),
            pct: sayi(it.pct),
            qty: sayi(it.qty),
            qtyPct: sayi(it.qtyPct),
            other: Boolean(it.other),
            subcategories: dizi(it.subcategories).map((s) => ({
              name: s.name || '',
              amount: sayi(s.amount),
              pct: sayi(s.pct),
            })),
          })),
          monthly: bastakiBoslariAt(
            dizi(kat.monthly).map((x) => ({ id: x.id, m: x.m, v: sayi(x.v) }))
          ),
        }
      : null,

    savings: sv
      ? {
          year: sayi(sv.year),
          amount: sayi(sv.amount),
          grossTotal: sayi(sv.grossTotal),
          netTotal: sayi(sv.netTotal),
          avgRate: sayi(sv.avgRate),
          trend: dizi(sv.trend).map((t) => ({ id: t.id, m: t.m, v: sayi(t.v) })),
        }
      : null,

    discounts: ad
      ? {
          items: dizi(ad.items).map((x) => mapIndirim(x, buYil)),
          hasMore: Boolean(ad.hasMore),
          customerCount: sayi(ad.customerCount),
          generalProducts: {
            count: sayi(gp.count),
            maxRate: sayi(gp.maxRate),
            nearestEnd: gp.nearestEnd || null,
          },
        }
      : null,
  };
}
